import createHistory from 'history/createBrowserHistory';
import { loadTranslations, setLocale, syncTranslationWithStore } from 'react-redux-i18n';
import { routerMiddleware } from 'react-router-redux';
import { applyMiddleware, compose, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import thunk from 'redux-thunk';
import rootReducer from 'ducks/rootReducer';
import rootSaga from 'ducks/rootSaga';
import {logoutUser, isUnauthorized} from 'ducks/user';
import { i18n_fi } from '../i18n_fi';
import { i18n_en } from '../i18n_en';
import moment from 'moment';
import 'moment/locale/fi'
import 'moment/locale/en-gb'
import {apiConfig} from 'service/api';
//import { composeWithDevTools } from 'redux-devtools-extension'

export const history = createHistory();

const sagaMiddleware = createSagaMiddleware();

const initialState = {};
const enhancers = [];
const middleware = [
  thunk,
  routerMiddleware(history),
  sagaMiddleware
];

if (process.env.NODE_ENV === 'development') {
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension());
  }
}

const composedEnhancers = compose(
  applyMiddleware(...middleware),
  ...enhancers
);

const store = createStore(
  rootReducer,
  initialState,
  composedEnhancers
);

syncTranslationWithStore(store);
store.dispatch(loadTranslations({ fi: i18n_fi, en: i18n_en }));
store.dispatch(setLocale('fi'));
moment.locale('fi');

sagaMiddleware.run(rootSaga);

//Hook common error handling of 401 api responses
apiConfig.errorHandler = (error) => {
  const { user } = store.getState().userState;
  if (user && isUnauthorized(error)) {
    store.dispatch(logoutUser());
  }
  return error;
}

export default store;



// WEBPACK FOOTER //
// ./src/store/storeConfig.js